const ANNEXE = {
  GET_ALL_ANNEXES: 'risk/annexe-get-all' as 'risk/annexe-get-all',
  CREATE_ANNEXE: 'risk/annexe-insert' as 'risk/annexe-insert',
  GET_CREATE_ANNEXE: 'risk/annexe-create' as 'risk/annexe-create',
  GET_ONE_ANNEXE: 'risk/annexe-get' as 'risk/annexe-get',
  UPDATE_ANNEXE: 'risk/annexe-update' as 'risk/annexe-update',
}

export default ANNEXE
